<template>
  <v-card>
    <v-layout justify-center>
    <!--タイトル-->
      <v-card-title class="head title-center">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon color="black" class="ml-2 mt-1">{{ icon }}</v-icon>
    </v-card-title>
    </v-layout>
    <p style="font-size:1.3rem; margin-left:1rem;">
    <router-link :to="{ path: '/Service'}" append  class="sitemap-title">サービス</router-link>
    </p>
    <div style="margin-left:2rem;">
    <div>
    <a href="https://konniesystem.co.jp/hp_maintenance/">ホームページ運用保守</a>
    </div>
    <div>
    <router-link :to="{ path: '/Service/Maintenance'}" append>システム運用保守</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Service/supportConference'}" append>学会サポート</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Service/academicSite'}" append>学術研究機関向けサイト作成</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Service/supportOSS'}" append>OSS製品のサポート</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Service/Commissioned'}" append>受託開発</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Service/Investigation'}" append>研究開発</router-link>
    </div>
    </div>

<p style="font-size:1.3rem; margin-top:2rem; margin-left:1rem;">
    <router-link :to="{ path: '/Products'}" append  class="sitemap-title">製品案内</router-link>
</p>
<div style="margin-left:2rem;">
    <div>
    <router-link :to="{ path: '/Products/Search'}" append>全文検索システム</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Products/Elearning'}" append>e-Learningシステム</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Products/reserveDental'}" append>歯科予約システム</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Products/reserveMedical'}" append>会議システム</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Products/registration'}" append>学術集会向けオンライン演題登録/査読システム</router-link>
    </div>
    <div>
    <router-link :to="{ path: '/Products/participation'}" append>学術集会向け事前参加登録システム</router-link>
    </div>
</div>
<p style="font-size:1.3rem; margin-top:2rem; margin-left:1rem;">
    <router-link :to="{ path: '/Company'}" append>会社情報</router-link>
</p>
<p style="font-size:1.3rem; margin-top:2rem; margin-left:1rem;">
    <router-link :to="{ path: '/Contact'}" append>お問い合わせ</router-link>
</p>
<p style="font-size:1.3rem; margin:2rem 1rem; padding-bottom:1rem;">
    <router-link :to="{ path: '/Privacy'}" append>プライバシーポリシー</router-link>
</p>
  </v-card>
</template>

<style>
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: 'サイトマップ',
      icon: 'mdi-map-search-outline'
    }
  }
}
</script>
